export const serviceSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      '@id': 'https://www.datauniverse.co.kr/#website',
      url: 'https://www.datauniverse.co.kr',
      name: '㈜데이터유니버스',
    },
    {
      '@type': 'Organization',
      '@id': 'https://www.datauniverse.co.kr/#organization',
      name: '㈜데이터유니버스',
      url: 'https://www.datauniverse.co.kr',
      logo: {
        '@type': 'ImageObject',
        url: 'https://img.datau.co.kr/dulogo.png',
      },
      sameAs: [
        'https://www.youtube.com/@%EB%8D%B0%EC%9D%B4%ED%84%B0%EC%9C%A0%EB%8B%88%EB%B2%84%EC%8A%A4',
      ],
    },
    {
      '@type': 'WebPage',
      '@id': 'https://www.datauniverse.co.kr/service/#webpage',
      url: 'https://www.datauniverse.co.kr/service',
      name: '서비스 | ㈜데이터유니버스',
      description:
        '㈜데이터유니버스는 스마트피싱보호, 휴대폰분실보호, 휴대폰가족보호, 휴대폰쿠폰지갑, 이벤트유, 오토콜 서비스를 제공합니다.',
      isPartOf: {
        '@id': 'https://www.datauniverse.co.kr/#website',
      },
    },
    {
      '@type': 'SoftwareApplication',
      name: '스마트피싱보호(Anti-Scam)',
      url: 'https://www.antiscam.co.kr',
      description:
        '국내 최초 보이스피싱 예방 서비스! 피싱 의심 전화 및 스미싱 알림, 악성앱 검사, 가족 피싱 보호 기능까지',
      applicationCategory: 'MobileApplication',
      operatingSystem: ['Android', 'iOS'],
      offers: [
        {
          '@type': 'Offer',
          url: 'https://www.antiscam.co.kr',
          priceCurrency: 'KRW',
          price: '1650',
        },
        {
          '@type': 'Offer',
          url: 'https://play.google.com/store/apps/details?id=com.datauniverse.antiscam',
          priceCurrency: 'KRW',
          price: '1650',
        },
        {
          '@type': 'Offer',
          url: 'https://apps.apple.com/kr/app/%EC%8A%A4%EB%A7%88%ED%8A%B8%ED%94%BC%EC%8B%B1%EB%B3%B4%ED%98%B8-%EB%B3%B4%EC%9D%B4%EC%8A%A4%ED%94%BC%EC%8B%B1-%EC%9D%98%EC%8B%AC%EB%B2%88%ED%98%B8-%EC%88%98%EC%8B%A0-%EC%8B%9C-%EB%B0%9C%EC%8B%A0%EC%9E%90-%EB%B2%88%ED%98%B8/id1452978615',
          priceCurrency: 'KRW',
          price: '1650',
        },
      ],
      screenshot: {
        '@type': 'ImageObject',
        url: 'https://images.antiscam.co.kr/partner/antiscam_og_img.jpg',
      },
    },
    {
      '@type': 'SoftwareApplication',
      name: '휴대폰분실보호(MFinder)',
      url: 'https://www.mfinder.co.kr',
      description:
        '휴대폰 분실 시 가장 쉽게 찾는 방법! 분실폰 주변인과 영상 통화, 위치 추적, 회수 요청, 데이터 백업 및 삭제까지 한번에',
      applicationCategory: 'MobileApplication',
      operatingSystem: ['Android'],
      offers: [
        {
          '@type': 'Offer',
          url: 'https://www.mfinder.co.kr',
          priceCurrency: 'KRW',
          price: '2200',
        },
        {
          '@type': 'Offer',
          url: 'https://play.google.com/store/apps/details?id=kr.co.datau.mfinder',
          priceCurrency: 'KRW',
          price: '2200',
        },
      ],
      screenshot: {
        '@type': 'ImageObject',
        url: 'https://img.mfinder.co.kr/titleimg/mfinder_og_img.jpg',
      },
    },
    {
      '@type': 'SoftwareApplication',
      name: 'MFinder Global',
      url: 'https://www.mfinder.ai',
      description:
        'Lost your phone? Use MFinder to locate, lock, and protect your mobile with GPS tracking, data backup, and emergency alerts.',
      applicationCategory: 'MobileApplication',
      operatingSystem: ['Android'],
      offers: [
        {
          '@type': 'Offer',
          url: 'https://www.mfinder.ai',
        },
        {
          '@type': 'Offer',
          url: 'https://play.google.com/store/apps/details?id=co.kr.datau.mfinder_global',
        },
      ],
      screenshot: {
        '@type': 'ImageObject',
        url: 'https://img.mfinder.ai/banner/global_mfinder_og_img.jpg',
      },
    },
    {
      '@type': 'SoftwareApplication',
      name: '휴대폰가족보호(Familycare)',
      url: 'https://www.familycare.ai',
      description:
        '언제 어디서든 우리 가족 위치와 안부 확인! 안심콜, 안심메시지, 영상통화, 낙상 감지, 주변 SOS 요청, 안심장소 진입&이탈 알림',
      applicationCategory: 'MobileApplication',
      operatingSystem: ['Android', 'iOS'],
      offers: [
        {
          '@type': 'Offer',
          url: 'https://www.familycare.ai',
          priceCurrency: 'KRW',
          price: '3300',
        },
        {
          '@type': 'Offer',
          url: 'https://play.google.com/store/apps/details?id=co.kr.datau.tesla_p',
          priceCurrency: 'KRW',
          price: '3300',
        },
        {
          '@type': 'Offer',
          url: 'https://apps.apple.com/kr/app/%ED%9C%B4%EB%8C%80%ED%8F%B0%EA%B0%80%EC%A1%B1%EB%B3%B4%ED%98%B8-familycare-%EA%B0%80%EC%A1%B1-%EC%9C%84%EC%B9%98-%ED%99%95%EC%9D%B8/id6736891661',
          priceCurrency: 'KRW',
          price: '3300',
        },
      ],
      screenshot: {
        '@type': 'ImageObject',
        url: 'https://img.familycare.ai/Partner/familycare_og_img.jpg',
      },
    },
    {
      '@type': 'SoftwareApplication',
      name: '휴대폰쿠폰지갑(CouponWallet)',
      url: 'https://www.couponwallet.co.kr',
      description:
        '모바일 쿠폰 상시 할인은 물론, 초특가 할인 이벤트와 매월 제공되는 무료 쿠폰까지! 복잡했던 쿠폰 관리도 한번에!',
      applicationCategory: 'MobileApplication',
      operatingSystem: ['Android', 'iOS'],
      offers: [
        {
          '@type': 'Offer',
          url: 'https://www.couponwallet.co.kr',
          priceCurrency: 'KRW',
          price: '5500',
        },
        {
          '@type': 'Offer',
          url: 'https://play.google.com/store/apps/details?id=co.kr.datau.saturn_aos&hl=ko',
          priceCurrency: 'KRW',
          price: '5500',
        },
        {
          '@type': 'Offer',
          url: 'https://apps.apple.com/kr/app/%ED%9C%B4%EB%8C%80%ED%8F%B0%EC%BF%A0%ED%8F%B0%EC%A7%80%EA%B0%91-%EC%83%81%EC%8B%9C%ED%95%A0%EC%9D%B8-%ED%8A%B9%EA%B0%80%EC%BF%A0%ED%8F%B0/id6502936747',
          priceCurrency: 'KRW',
          price: '5500',
        },
      ],
      screenshot: {
        '@type': 'ImageObject',
        url: 'https://img.couponwallet.co.kr/partner/240924_151617_sgS6.jpeg.jpg',
      },
    },
    {
      '@type': 'SoftwareApplication',
      name: '오토콜(Autocall)',
      url: 'https://www.autocall.ai',
      description:
        '차량의 개인 연락처 노출 이제 그만! 오토콜로 내 전화번호 유출을 막고 범죄를 예방하세요.',
      applicationCategory: 'MobileApplication',
      operatingSystem: ['Android'],
      offers: [
        {
          '@type': 'Offer',
          url: 'https://www.autocall.ai',
          priceCurrency: 'KRW',
          price: '990',
        },
        {
          '@type': 'Offer',
          url: 'https://play.google.com/store/apps/details?id=kr.co.datau.ai.autocall',
          priceCurrency: 'KRW',
          price: '990',
        },
      ],
      screenshot: {
        '@type': 'ImageObject',
        url: 'https://images.autocall.ai/partner/autocall_og_img.jpg',
      },
    },
    {
      '@type': 'SoftwareApplication',
      name: '이벤트유(EventU)',
      url: 'https://www.eventu.co.kr',
      description:
        '경품 이벤트로 시작하는 앱테크! 지금 바로 참여하고 상품권, 기프티콘 등 경품 받으세요!',
      applicationCategory: 'MobileApplication',
      operatingSystem: ['Android', 'iOS'],
      offers: [
        {
          '@type': 'Offer',
          url: 'https://www.eventu.co.kr',
          priceCurrency: 'KRW',
          price: '0',
        },
        {
          '@type': 'Offer',
          url: 'https://play.google.com/store/apps/details?id=com.datau.eventu',
          priceCurrency: 'KRW',
          price: '0',
        },
        {
          '@type': 'Offer',
          url: 'https://apps.apple.com/kr/app/%EC%9D%B4%EB%B2%A4%ED%8A%B8%EC%9C%A0-eventu-%EA%B2%BD%ED%92%88%EC%9D%91%EB%AA%A8-%EC%95%B1%ED%85%8C%ED%81%AC-%EB%AA%A8%EB%B0%94%EC%9D%BC%EC%BF%A0%ED%8F%B0/id6602889410',
          priceCurrency: 'KRW',
          price: '0',
        },
      ],
      screenshot: {
        '@type': 'ImageObject',
        url: 'https://bimg.eventu.co.kr/images/eventu-og.jpg',
      },
    },
  ],
}
